import {useQuery} from '@apollo/client';
import compose from 'core/libs/helpers/compose.js';
import decodeId from 'core/libs/helpers/decodeId';
import encodeId from 'core/libs/helpers/encodeId';
import getQueryStringValue from 'core/libs/helpers/getQueryStringValue';
import log from 'core/libs/logger';
import HeroHeader from 'modules/common/HeroHeader';
import LoadingIndicator from 'modules/common/LoadingIndicator';
import NextButton from 'modules/common/NextButton';
import PropTypes from 'prop-types';
import React from 'react';
import {useIntl} from 'react-intl';
import {connect} from 'react-redux';
import ProjectInReview from '../components/ProjectInReview';
import ProjectReview from '../components/ProjectReview';
import ProjectSubmission from '../components/ProjectSubmission';
import PROJECT_SUBMISSIONS from '../graphql/projectSubmissions.graphql';

const {PARTNER} = process.env;

const ProjectContainer = (props) => {
  const intl = useIntl();
  const {formatMessage} = intl;
  const {
    step,
    isAdmin,
    nextStepProps,
    trackSlug,
    trackId,
    authenticated,
    isDegree,
  } = props;
  const project = step && step.project;
  const projectId = project && project.id;
  const {data, loading, error} = useQuery(PROJECT_SUBMISSIONS, {
    variables: {projectId},
    fetchPolicy: 'network-only',
    skip: !authenticated,
  });
  if (loading) return <LoadingIndicator />;
  if (error) return <p>ERROR: {error.message}</p>;
  const encodedTrackId = encodeId(`TrackType:${trackId}`);
  const userId = data && data.me && data.me.id;

  // Use reverse() method to get last subscription
  const subscriptionSet =
    data &&
    data.me &&
    data.me.subscriptionSet &&
    data.me.subscriptionSet.edges &&
    data.me.subscriptionSet.edges.slice().reverse();
  const subscription =
    subscriptionSet &&
    subscriptionSet.find(
      ({node: {cohort}}) => cohort.degree.slug === trackSlug,
    );
  /*   if (!subscription && !isAdmin && PARTNER === 'BARMEJ') {
    log("Error: we didn't find the correct subscription", {
      trackSlug,
      userId,
    });
  } */
  const projectSubmitted =
    data && data.me.projectsubmissionSet.edges.length > 0;
  let projectStatus = '';
  let projectReview = {};
  let files = [];
  let allProjectSubmission = [];
  let submissionIndex = '';
  if (projectSubmitted) {
    const submissionId = getQueryStringValue('submission');
    const currentSubmission = data.me.projectsubmissionSet.edges.findIndex(
      (submission) => decodeId(submission.node.id) == submissionId,
    );
    if (currentSubmission === -1) {
      submissionIndex = 0;
    } else {
      submissionIndex = currentSubmission;
    }
    projectStatus =
      data.me.projectsubmissionSet.edges[submissionIndex].node.status;
    projectReview =
      data.me.projectsubmissionSet.edges[submissionIndex].node.projectReview &&
      JSON.parse(
        data.me.projectsubmissionSet.edges[submissionIndex].node.projectReview,
      );
    files = data.me.projectsubmissionSet.edges[
      submissionIndex
    ].node.projectfileSet.edges.map((projectFile) => projectFile.node);
    allProjectSubmission = data.me.projectsubmissionSet.edges;
  }
  const hasSubscription = !!subscription;
  return (
    <>
      <HeroHeader title={step.name} trackSlug={trackSlug} isDegree={isDegree} />
      <>
        {!projectSubmitted ? (
          <ProjectSubmission
            hasSubscription={hasSubscription}
            description={step.project.description}
            projectId={step.project.id}
            trackId={encodedTrackId}
            partner={PARTNER}
            userId={userId}
          />
        ) : (
          <>
            {projectStatus === 'new' || projectStatus === 'in_review' ? (
              <ProjectInReview />
            ) : (
              <ProjectReview
                hasSubscription={hasSubscription}
                feedback={projectReview}
                files={files}
                projectStatus={projectStatus}
                step={step}
                allProjectSubmission={allProjectSubmission}
                trackId={encodedTrackId}
                partner={PARTNER}
                userId={userId}
                daysLeftUntilDeadline={120}
              />
            )}
          </>
        )}
      </>
      <div className="pv5 pb5 pl6-ns pl0 tc tl-ns">
        <NextButton
          pretext={`${formatMessage({
            id: 'continue',
          })} :`}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...nextStepProps}
          stepId={step.id}
        />
      </div>
    </>
  );
};

ProjectContainer.propTypes = {
  step: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  nextStepProps: PropTypes.object.isRequired,
  trackSlug: PropTypes.string.isRequired,
  trackId: PropTypes.number.isRequired,
  authenticated: PropTypes.bool.isRequired,
  isDegree: PropTypes.bool.isRequired,
};

const enhance = compose(
  connect(({user, auth}) => ({
    isAdmin: user.profile.data.is_admin,
    authenticated: auth.authenticated,
  })),
);

export default enhance(ProjectContainer);
